import React, { useState } from 'react';
import { ReviewTitle, ReviewBody, ReviewReply } from '.';
import { Card } from '@wix/design-system';
import { VisibilityDetector } from '@wix/app-market-components';
import { biLogger } from '../../../../../bi';
import type { ISolutionReview } from '../../../../../types/common/marketplace';
import { useConfigContext } from '../../../../../config-context';
import { appMarketReviewImpression } from '@wix/bi-logger-market/v2';

interface ISolutionReviewProps {
  review?: ISolutionReview;
  developerName: string;
  developerIcon: string;
  appName?: string;
  appId: string;
  index: number;
  averageRating: number;
  ratingCount: number;
}

export const SolutionReview = (props: ISolutionReviewProps) => {
  const [impressionSent, setImpressionSent] = useState(false);

  const onImpression = () => {
    if (!impressionSent) {
      biLogger.report(
        appMarketReviewImpression({
          appId: props?.appId,
          review_body: props?.review?.description,
          reviewsScore: props?.review?.rating,
          slug_id: props?.appName,
          review_index: props?.index,
          dev_comment: !!props?.review?.replies[0],
        }),
      );
      setImpressionSent(true);
    }
  };
  const { isMobile } = useConfigContext();

  return (
    <VisibilityDetector onVisible={() => onImpression()}>
      <Card>
        <span vocab="https://schema.org/" typeof="Review">
          <ReviewTitle
            name={props.review.author.userName}
            publishDate={props.review.publishedAt}
            rating={props.review.rating}
          />
          <span property="itemReviewed" typeof="SoftwareApplication">
            <meta property="name" content={props.appName} />
            <link
              property="applicationCategory"
              href="https://schema.org/WebApplication"
            />
          </span>
          <ReviewBody
            id={props.review.id}
            body={props.review.description}
            title={props.review.title}
            isMobile={isMobile}
          />
          {props.review.replies && props.review.replies[0] && (
            <ReviewReply
              reply={props.review.replies[0]}
              developerIcon={props.developerIcon}
              developerName={props.developerName}
              isMobile={isMobile}
            />
          )}
        </span>
      </Card>
    </VisibilityDetector>
  );
};
